import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryTabs from './components/CategoryTabs';
import FeaturedMovies from './components/FeaturedMovies';
import LatestUpdates from './components/LatestUpdates';
import FAQSection from './components/FAQSection';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '木瓜影院',
    url: 'https://www.muguayingyuan.com',
    description: '木瓜影院是您的首选在线观影平台，汇聚海量高清电影、电视剧、综艺、动漫资源，无需注册即可免费畅看。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.muguayingyuan.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '木瓜影院',
    url: 'https://www.muguayingyuan.com',
    description: '国内领先的免费在线影视资源平台',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'contact@muguayingyuan.com',
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategoryTabs />
          <FeaturedMovies />
          <LatestUpdates />
          <FAQSection />
        </main>
        <Footer />
      </div>
    </>
  );
}